import script from "./PaymentsPageCreatorUpcomingRenewalsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentsPageCreatorUpcomingRenewalsTab.vue?vue&type=script&setup=true&lang=js"

import "./PaymentsPageCreatorUpcomingRenewalsTab.vue?vue&type=style&index=0&id=38f6d1ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f6d1ee"]])

export default __exports__